export default __webpack_public_path__ + "static/media/learn_more_page_1.8b6243e0.jpg";